import { RFIProps } from "../interfaces/rfi_types"
import { API, APIResponse } from "@/components/_Shared/API/API"
import { CREATE_RFI, GET_RFI_LIST, UPDATE_RFI, GET_RFI_BY_ID, GET_RFI_BY_USER, DELETE_RFI, MARK_RFI_AS_CLOSED } from "./Endpoints/rfis"

export async function createRFI(rfi: RFIProps): Promise<APIResponse> {
    const response = API.post<void>(CREATE_RFI, rfi)
    return response
}

export async function getRFIList(): Promise<APIResponse<RFIProps[]>> {
    const response = API.get<RFIProps[]>(GET_RFI_LIST)
    return response
}

export async function updateRFI(rfi: RFIProps): Promise<APIResponse> {
    const response = API.put<void>(UPDATE_RFI.replace("{id}", rfi.RFI_id ?? ""), rfi)
    return response 
}

export async function getRFI(id: string): Promise<APIResponse<RFIProps>> {
    const response = API.get<RFIProps>(GET_RFI_BY_ID.replace("{id}", id))
    return response
}

export async function getRFIByUser(email: string): Promise<APIResponse<RFIProps[]>> {
    const response = API.get<RFIProps[]>(GET_RFI_BY_USER.replace("{email}", email))
    return response
}

export async function deleteRFI(rfi: RFIProps): Promise<APIResponse> {
    const response = API.delete<void>(DELETE_RFI.replace("{id}", rfi.RFI_id ?? ""))
    return response
}

export async function markRFIAsClosed(rfiId: string): Promise<APIResponse> {
    const encodedID = encodeURIComponent(rfiId)
    const response = API.put<void>(MARK_RFI_AS_CLOSED.replace("{id}", encodedID))
    return response
}